import { createRouter, createWebHistory } from 'vue-router';
import AppLayout from '@/layout/AppLayout.vue';
import auth from '@/middleware/auth';
import shifts from '@/middleware/shifts';
import initTransaction from '@/middleware/InitTransaction';
import Permission from '@/middleware/checkPermission.middleware';
const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            component: AppLayout,
            meta: {
                middleware: [auth, Permission],
                permission: 'DashBoard_Read'
            },
            redirect: '/dashboard',
            children: [
                {
                    path: 'dashboard',
                    name: 'dashboard',
                    meta: { permission: 'DashBoard_Read' },
                    component: () => import('@/views/Dashboard.vue')
                },
                {
                    path: '/man/Products',
                    name: 'Products',
                    meta: { permission: 'Item_Read' },
                    component: () => import('@/views/admin/Products.vue')
                },
                {
                    path: '/man/import-products',
                    meta: { permission: 'AddStock_Read' },
                    name: 'ImportProducts',
                    component: () => import('@/views/admin/ImportProducts/ImportProducts.vue')
                },
                {
                    path: '/man/display-gold-list',
                    // meta: { permission: 'AddStock_Read' },
                    name: 'DisplayGoldList',
                    component: () => import('@/views/admin/DisplayGoldList.vue')
                },
                {
                    path: '/man/display-brands',
                    // meta: { permission: 'AddStock_Read' },
                    name: 'DisplayBrands',
                    component: () => import('@/views/admin/DisplayBrands.vue')
                },
                {
                    path: '/man/config-exclamation',
                    // meta: { permission: 'AddStock_Read' },
                    name: 'ConfigExclamation',
                    component: () => import('@/views/admin/ConfigExclamation.vue')
                },
                {
                    path: '/man/config-time',
                    // meta: { permission: 'AddStock_Read' },
                    name: 'ConfigTime',
                    component: () => import('@/views/admin/ConfigTime.vue')
                },
                {
                    path: '/man/config-weight',
                    // meta: { permission: 'AddStock_Read' },
                    name: 'ConfigWeight',
                    component: () => import('@/views/admin/ConfigWeight.vue')
                },
                {
                    path: '/man/config-kiosk',
                    name: 'ConfigKiosk',
                    component: () => import('@/views/admin/ConfigKiosk.vue')
                },
                {
                    path: '/man/config-interface-kiosk',
                    name: 'ConfigInterfaceKiosk',
                    component: () => import('@/views/admin/ConfigInterfaceKiosk.vue')
                },
                {
                    path: '/man/config-items-kiosk',
                    name: 'ConfigItemsKiosk',
                    component: () => import('@/views/admin/ConfigItemsKiosk.vue')
                },
                {
                    path: '/man/import-products/new-jewelry',
                    name: 'AddNewProductsJewelryG',
                    component: () => import('@/views/admin/ImportProducts/AddNewProductsJewelryG.vue')
                },
                {
                    path: '/man/import-products/new-exchange',
                    name: 'AddNewProductsExchangeG',
                    component: () => import('@/views/admin/ImportProducts/AddNewProductsExchangeG.vue')
                },
                {
                    path: '/man/inventory-check',
                    name: 'InventoryCheck',
                    meta: { permission: 'AuditStock_Read' },
                    component: () => import('@/views/admin/InventoryCheck/InventoryCheck.vue')
                },
                {
                    path: '/man/add-inventory-check',
                    name: 'AddInventoryCheck',
                    meta: { permission: 'AuditStock_Read' },
                    component: () => import('@/views/admin/InventoryCheck/AddInventoryCheck.vue')
                },
                {
                    // Danh sách phiếu kiểm kê VTD là một tab trong /man/inventory-check,
                    // không có route riêng — chỉ màn tít mới cần trang riêng.
                    path: '/man/add-inventory-check-nfc',
                    name: 'AddInventoryCheckNfc',
                    meta: { permission: 'AuditStock_Read' },
                    component: () => import('@/views/admin/InventoryCheck/AddInventoryCheckNfc.vue')
                },
                {
                    path: '/man/manage-transfer',
                    name: 'ManageTransfer',
                    meta: { permission: 'TransferStock_Read' },
                    component: () => import('@/views/admin/ManageTransfers/ManageTransfer.vue')
                },
                {
                    path: '/man/manage-transfer/new',
                    name: 'AddNewTransfer',
                    component: () => import('@/views/admin/ManageTransfers/AddNewTransfer.vue')
                },
                {
                    path: '/man/purchase-no-invoice',
                    name: 'PurchaseNoInvoice',
                    component: () => import('@/views/admin/PurchaseNoInvoiceReport.vue')
                },
                {
                    path: '/man/purchase-no-invoice-vts',
                    name: 'PurchaseNoInvoiceVTS',
                    component: () => import('@/views/admin/PurchaseNoInvoiceReportVTS.vue')
                },
                {
                    path: '/man/manage-transfer/new-vts',
                    name: 'AddNewTransferVTS',
                    component: () => import('@/views/admin/ManageTransfers/AddNewTransfer_VTS.vue')
                },
                {
                    path: '/man/manage-transfer/approval',
                    name: 'ApprovalTransfer',
                    component: () => import('@/views/admin/ManageTransfers/ApprovalTransfer.vue')
                },
                {
                    path: '/man/manage-transfer/approval-vts',
                    name: 'ApprovalTransferVTS',
                    component: () => import('@/views/admin/ManageTransfers/ApprovalTransfer_VTS.vue')
                },

                {
                    path: '/man/purchase-return-new',
                    name: 'PurchaseReturnNew',
                    component: () => import('@/views/admin/AddNewPurchaseReturn.vue')
                },
                {
                    path: '/man/damage-items-new',
                    name: 'DamageItemNew',
                    component: () => import('@/views/admin/DamegeItems/AddDamegeItem.vue')
                },
                {
                    path: '/man/damage-items-new-vts',
                    name: 'DamageItemNewVTS',
                    component: () => import('@/views/admin/DamegeItems/AddDamegeItemVTS.vue')
                },
                {
                    path: '/man/customers',
                    name: 'Customers',
                    meta: { permission: 'Customer_Read' },
                    component: () => import('@/views/admin/Customers.vue')
                },
                {
                    path: '/man/crime',
                    name: 'crime',
                    component: () => import('@/views/admin/Crime.vue')
                },
                {
                    path: '/man/price-list',
                    name: 'PriceList',
                    meta: { permission: 'MaterialPriceTable_Read' },
                    component: () => import('@/views/admin/PriceList/PriceList.vue')
                },
                {
                    path: '/man/sell-price-list',
                    name: 'PriceSellList',
                    component: () => import('@/views/admin/SellPriceTable/SellPriceTable.vue')
                },
                {
                    path: '/man/price-list-code',
                    name: 'PriceListCode',
                    meta: { permission: 'MaterialPrice_Read' },
                    component: () => import('@/views/admin/PriceList/PriceListCode.vue')
                },
                {
                    path: '/man/price-code',
                    name: 'PriceCode',
                    meta: { permission: 'PriceCode_Read' },
                    component: () => import('@/views/admin/PriceCode/PriceCodes.vue')
                },
                {
                    path: '/man/price-code-table',
                    name: 'PriceCodeTable',
                    meta: { permission: 'PriceCodeTable_Read' },
                    component: () => import('@/views/admin/priceCodeTable/PriceCode.vue')
                },

                {
                    path: '/man/rules-vts',
                    name: 'RulesVTS,',
                    component: () => import('@/views/admin/RulesVTS/RulesVTS.vue')
                },
                {
                    path: '/man/gold-jewelry',
                    name: 'GoldJewelry',
                    component: () => import('@/views/admin/PriceRule/GoldJewelry.vue')
                },
                {
                    path: '/man/warranty-setup',
                    name: 'WarrantySetup',
                    component: () => import('@/views/admin/Warranty/WarrantySetup.vue')
                },
                {
                    path: '/man/warranty-service',
                    name: 'WarrantyService',
                    component: () => import('@/views/admin/Warranty/WarrantyService.vue')
                },
                {
                    path: '/man/customers-rank',
                    name: 'CustomerRank',
                    component: () => import('@/views/admin/CustomerRank.vue')
                },
                {
                    path: '/man/vendors',
                    name: 'Vendors',
                    meta: { permission: 'Supplier_Read' },
                    component: () => import('@/views/admin/Vendors.vue')
                },
                {
                    path: '/man/group-vendors',
                    name: 'GroupVendor',
                    component: () => import('@/views/admin/GroupVendor.vue')
                },
                {
                    path: '/man/unit',
                    name: 'Unit',
                    meta: { permission: 'Unit_Read' },
                    component: () => import('@/views/admin/ManageUnit.vue')
                },
                {
                    path: '/man/unit-group',
                    name: 'UnitGroup',
                    meta: { permission: 'UnitGroup_Read' },
                    component: () => import('@/views/admin/ManageUnitGroup.vue')
                },
                {
                    path: '/man/users',
                    name: 'Users',
                    meta: { permission: 'User_Read' },
                    component: () => import('@/views/admin/ManageUsers.vue')
                },
                {
                    path: '/man/roles',
                    name: 'Roles',
                    meta: { permission: 'Role_Read' },
                    component: () => import('@/views/admin/ManagerRole.vue')
                },
                {
                    path: '/man/setup-store',
                    name: 'SetupStore',
                    meta: { permission: 'Branch_Read' },
                    component: () => import('@/views/admin/SetupStore.vue')
                },
                {
                    path: '/man/system-setting',
                    name: 'SystemSetting',
                    component: () => import('@/views/admin/SystemSetting.vue')
                },
                {
                    path: '/man/stall-configuration',
                    name: 'StallConfiguration',
                    meta: { permission: 'Counter_Read' },
                    component: () => import('@/views/admin/StallConfiguration.vue')
                },
                {
                    path: '/man/voucher',
                    name: 'Voucher',
                    component: () => import('@/views/admin/ManageVoucher.vue')
                },
                {
                    path: '/man/voucher-partner',
                    name: 'VoucherPartner',
                    component: () => import('@/views/admin/evoucher/VoucherPartner.vue')
                },
                {
                    path: '/man/voucher-batch',
                    name: 'VoucherBatchList',
                    component: () => import('@/views/admin/evoucher/VoucherBatchList.vue')
                },
                {
                    path: '/man/voucher-batch/:id',
                    name: 'VoucherBatchDetail',
                    component: () => import('@/views/admin/evoucher/VoucherBatchDetail.vue')
                },
                {
                    path: '/man/voucher-report',
                    name: 'VoucherReport',
                    component: () => import('@/views/admin/evoucher/VoucherReport.vue')
                },
                {
                    path: '/man/coupon',
                    name: 'Coupon',
                    component: () => import('@/views/admin/ManageCoupon.vue')
                },
                {
                    path: '/man/sale-off',
                    name: 'SaleOff',
                    component: () => import('@/views/admin/SaleOff.vue')
                },
                {
                    path: '/man/DetailPriceBook',
                    name: 'DetailPriceBook',
                    component: () => import('@/views/admin/DetailPriceBook.vue')
                },
                {
                    path: '/man/cash-book',
                    name: 'CashBook',
                    meta: { permission: 'CashBook_Read' },
                    component: () => import('@/views/admin/CashBook.vue')
                },
                {
                    path: '/man/branch',
                    name: 'Branch',
                    component: () => import('@/views/admin/ManageBranch.vue')
                },
                {
                    path: '/man/product/:status',
                    name: 'EditProduct',
                    component: () => import('@/views/admin/SaveProduct.vue')
                },
                {
                    path: '/man/create-services',
                    name: 'CreateServices',
                    component: () => import('@/views/admin/CreateServices.vue')
                },
                {
                    path: '/man/products-group',
                    name: 'ProductsGroup',
                    meta: { permission: 'ItemGroup_Read' },
                    component: () => import('@/views/admin/ProductsGroup.vue')
                },
                {
                    path: '/man/ar-invoice',
                    name: 'ARInvoice',
                    meta: { permission: 'SaleInvoice_Read' },
                    component: () => import('@/views/admin/ARInvoice.vue')
                },
                {
                    path: '/man/ar-invoice-gold-jewelry',
                    name: 'ARInvoiceGoldJewelry',
                    meta: { permission: 'SaleInvoice_Read' },
                    component: () => import('@/views/admin/ARInvoiceGoldJewelry.vue')
                },
                {
                    path: '/man/list-order',
                    name: 'ListOrder',
                    meta: { permission: 'SaleOrder_Read' },
                    component: () => import('@/views/admin/ListOrder.vue')
                },
                {
                    path: '/man/export-products',
                    name: 'ExportProducts',
                    meta: { permission: 'ReturnItem_Read' },
                    component: () => import('@/views/admin/ExportProducts.vue')
                },
                {
                    path: '/man/purchase',
                    name: 'Purchase',
                    meta: { permission: 'Buying_Read' },
                    component: () => import('@/views/admin/Purchase.vue')
                },
                {
                    path: '/man/guarantee',
                    name: 'ManageGuarantee',
                    component: () => import('@/views/admin/ManageGuarantee.vue')
                },
                {
                    path: '/man/purchase-returns',
                    name: 'PurchaseReturns',
                    component: () => import('@/views/admin/PurchaseReturns.vue')
                },
                {
                    path: '/man/damage-items',
                    name: 'DamageItems',
                    meta: { permission: 'ReleaseStock_Read' },
                    component: () => import('@/views/admin/DamegeItems/DamageItems.vue')
                },
                {
                    path: '/man/orders',
                    name: 'Orders',
                    component: () => import('@/views/admin/Orders.vue')
                },
                {
                    path: '/man/me',
                    name: 'UserInfo',
                    component: () => import('@/views/admin/UserInfo.vue')
                },
                {
                    path: '/man/order-delivery',
                    name: 'OrderDelivery',
                    component: () => import('@/views/admin/OrderDelivery.vue')
                },
                {
                    path: '/man/stock-takes',
                    name: 'StockTakes',
                    component: () => import('@/views/admin/StockTakes.vue')
                },
                {
                    path: '/man/stock-takes/new',
                    name: 'StockTakesNews',
                    component: () => import('@/views/admin/AddNewStockTakes.vue')
                },
                {
                    path: 'man/payment',
                    name: 'Payment',
                    meta: { permission: 'PaymentMethod_Read' },
                    component: () => import('@/views/admin/Payment.vue')
                },
                {
                    path: 'man/inventory-report',
                    name: 'InventoryReport',
                    meta: { permission: 'StockReport_Read' },
                    component: () => import('@/views/admin/InventoryReport.vue')
                },
                {
                    path: 'man/inventory-ledger-report',
                    name: 'InventoryLedgerReport',
                    meta: { permission: 'StockReport_Read' },
                    component: () => import('@/views/admin/InventoryLedgerReport.vue')
                },
                {
                    path: 'man/gold-report',
                    name: 'GoldReport',
                    meta: { permission: 'StockReport_Read' },
                    component: () => import('@/views/admin/GoldReport.vue')
                },
                {
                    path: 'man/searchSerial',
                    name: 'searchSerial',
                    component: () => import('@/views/admin/SearchSerial.vue')
                },
                {
                    path: 'man/state-bank-report',
                    name: 'StateBankReport',
                    meta: { permission: 'StockReport_Read' },
                    component: () => import('@/views/admin/StateBankReport.vue')
                },
                {
                    path: 'man/shifts-report',
                    name: 'ShiftsReport',
                    component: () => import('@/views/admin/ShiftsReport.vue')
                },
                {
                    path: 'man/cash-balance-report',
                    name: 'CashBalanceReport',
                    component: () => import('@/views/admin/CashBalanceReport.vue')
                },
                {
                    path: 'man/partner-weight-report',
                    name: 'PartnerWeightReport',
                    component: () => import('@/views/admin/PartnerWeightReport.vue')
                },
                {
                    path: 'man/customer-debt-adjustment',
                    name: 'CustomerDebtAdjustment',
                    meta: { permission: 'CustomerAdjustment_Read' },
                    component: () => import('@/views/admin/CustomerDebtAdjustment.vue')
                },
                {
                    path: 'man/sap-sync-report',
                    name: 'SapSyncReport',
                    component: () => import('@/views/admin/SapSyncReport.vue')
                },
                {
                    path: 'man/counter-stock-aging-report',
                    name: 'CounterStockAgingReport',
                    component: () => import('@/views/admin/CounterStockAgingReport.vue')
                },
                {
                    path: 'man/exchange-rate',
                    name: 'ExchangeRate',
                    component: () => import('@/views/admin/ExchangeRate.vue')
                },
                {
                    path: '/man/price-table',
                    name: 'PriceTable',
                    component: () => import('@/views/admin/PriceTable.vue')
                }
            ]
        },
        {
            path: '/sale/sale-page',
            name: 'sale',
            meta: {
                middleware: [auth, initTransaction, shifts]
            },
            component: () => import('@/views/client/SalePage.vue')
        },
        {
            path: '/sale/manage-revenue',
            name: 'revenue',
            component: () => import('@/views/client/ManageRevenue.vue')
        },

        {
            path: '/pages/notfound',
            name: 'notfound',
            component: () => import('@/views/pages/NotFound.vue')
        },

        {
            path: '/login',
            name: 'login',
            component: () => import('@/views/pages/auth/Login.vue')
        },
        {
            path: '/forgot-password',
            name: 'forgotPassword',
            component: () => import('@/views/pages/auth/ForgotPassword.vue')
        },
        {
            path: '/forgot-password/confirm/:id',
            name: 'forgotPasswordConfirm',
            component: () => import('@/views/pages/auth/ForgotPassword.vue')
        },
        {
            path: '/forgot-password/success/:id',
            name: 'forgotPasswordSuccess',
            component: () => import('@/views/pages/auth/ForgotPassword.vue')
        },
        {
            path: '/auth/access',
            name: 'accessDenied',
            component: () => import('@/views/pages/auth/Access.vue')
        },
        {
            path: '/auth/error',
            name: 'error',
            component: () => import('@/views/pages/auth/Error.vue')
        },
        {
            path: '/invoice-order-form',
            name: 'invoice-order-form',
            component: () => import('@/components/InvoiceOrderForm.vue')
        },
        {
            path: '/open-shifts',
            name: 'open-shifts',
            component: () => import('@/views/pages/auth/ShiftsCheck.vue')
        }
    ]
});

function nextFactory(context, middleware, index) {
    const subsequentMiddleware = middleware[index];
    if (!subsequentMiddleware) return context.next;
    return (...parameters) => {
        context.next(...parameters);

        const nextMiddleware = nextFactory(context, middleware, index + 1);
        subsequentMiddleware({ ...context, next: nextMiddleware });
    };
}

router.beforeEach((to, from, next) => {
    if (to.meta.middleware) {
        const middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware];

        const context = {
            from,
            next,
            router,
            to
        };
        const nextMiddleware = nextFactory(context, middleware, 1);

        return middleware[0]({ ...context, next: nextMiddleware });
    }
    return next();
});

export default router;
